import { useState, useRef } from 'react';
import { IconButton } from "@mui/material";
import voiceAxios from '../../../functions/voiceRequestInterceptor'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import Modal from '@mui/material/Modal'
import Box from "@mui/material/Box";
import { useTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '40%',
  width: '250px',
  height: '60px',
  padding: '10px',
  borderRadius: '4px',
  direction: 'rtl',
  textAlign: 'center',
  background: 'white',
  overflow: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export default function AttachFile(props) {
  const { t } = useTranslation('translation', { keyPrefix: 'chat' });

  const inputFileImage = useRef(null);

  // const [uploadStatus, setUploadStatus] = useState('');
  const handleUploadFile = (file) => {
    props.startToUploading(file)
    // setUploadStatus('uploading')

    const data = new FormData();
    data.append('file', file, file.name)

    voiceAxios.post('/upload/', data)
    .then((response) => {
      console.log(response)
      props.sendMessage({
        file: response.data.id,
        type: 'voice',
        message: ''
      })
      // setUploadStatus('uploaded')
    })
    .catch((error) => {
      console.log(error);
      // setUploadStatus('fail')
    });
  }

  const [openModal, setOpenModal] = useState(false)
  const handleFile = (e) => {
    const file = e.files[0]
    if (file.type === "image/jpeg") {
      handleUploadFile(file)
    } else {
      setOpenModal(true)
    }
  }

  return (
   <span style={{display: 'flex', justifyContent: 'center', alignItems: "center"}}>
     <PopupState variant="popover" popupId="demo-popup-menu">
       {(popupState) => (
        <>
          <IconButton {...bindTrigger(popupState)} >
            <AttachFileIcon/>
            <input
             style={{display: 'none'}}
             type="file"
             accept=".jpg,.jpeg"
             onChange={(e) => handleFile(e.target)}
             ref={inputFileImage}
            />
          </IconButton>
          <Menu {...bindMenu(popupState)} onClick={popupState.close}>
            <MenuItem onClick={() => inputFileImage.current.click()}>
              {t('select_from_gallary')}
            </MenuItem>
          </Menu>
        </>
       )}
     </PopupState>
     <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
     >
       <Box sx={style}>
        <span>
          {t('upload_picture_error')}
        </span>
       </Box>
     </Modal>
   </span>
  )
}
